/**
 * TanStack Query hooks for `dynamic-commission-by-sku`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	dynamicCommissionBySkuQueryKeys,
	type CreateDynamicCommissionBySkuBody,
	type ListDynamicCommissionBySkuResponse,
	type DynamicCommissionBySkuRow,
} from "./api";

export function useDynamicCommissionBySkuList(): UseQueryResult<ListDynamicCommissionBySkuResponse, Error> {
	return useQuery({
		queryKey: dynamicCommissionBySkuQueryKeys.list(),
		queryFn: list,
	});
}

export function useDynamicCommissionBySkuCreate(): UseMutationResult<DynamicCommissionBySkuRow, Error, CreateDynamicCommissionBySkuBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dynamicCommissionBySkuQueryKeys.all });
		},
	});
}

export function useDynamicCommissionBySkuDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dynamicCommissionBySkuQueryKeys.all });
		},
	});
}
